module.exports = __webpack_public_path__ + "static/media/Prognosis-Active.8cceef1a.svg";